module.exports = __webpack_public_path__ + "img/close.651f17be.svg";